<template>
  <div class="priceList" v-if="priceData">
    <table>
      <th id="item">品名</th>
      <th id="material">カラー</th>
      <th id="size">サイズWHD(mm)</th>
      <th id="sum">数</th>
      <th id="price" class="price">金額</th>
      <tr v-for="(price,index) in itemList" :key="'price-' + index">
        <td v-if="index===0">{{priceData.itemName}}</td>
        <td v-else></td>
        <td>{{itemType(price.objectDtlType)}}{{price.material}}</td>
        <td>{{sizeName(price.width, price.height, price.depth)}}</td>
        <td>{{price.count}}</td>
        <td class="price" v-if="(itemList.length - 1)===index">{{formatPrice(profitPrice(priceData.itemPrice))}}</td>
        <td class="price" v-else></td>
      </tr>
      <tr v-for="(option,index) in optionShelfList" :key="'shelf-' + index">
        <td>(op){{option.itemName}}</td>
        <td>{{option.material}}</td>
        <td>{{sizeName(option.width, option.height, option.depth)}}</td>
        <td>{{option.count}}</td>
        <td class="price">{{formatPrice(profitPrice(option.price))}}</td>
      </tr>
      <tr v-for="(option,index) in optionFillerList" :key="'option-' + index">
        <td>(op){{option.itemName}}</td>
        <td>{{option.material}}</td>
        <td>{{sizeName(option.width, option.height, option.depth)}}</td>
        <td>{{option.count}}</td>
        <td class="price">{{formatPrice(profitPrice(option.price))}}</td>
      </tr>
      <tr v-if="priceData.constructPrice">
        <td>組立技術料</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(priceData.constructPrice))}}</td>
      </tr>
      <tr class="total s_separator">
        <td>小計</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price pickup">{{formatPrice(profitPrice(priceData.subTotalPrice))}}</td>
      </tr>
      <tr v-if="isCalcDelivery">
        <td>配送料</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(priceData.delivaryPrice))}}</td>
      </tr>
      <tr>
        <td>消費税(10%)</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(totalTax))}}</td>
      </tr>
      <tr class="total s_separator">
        <td>ご注文数 × {{dcProductCount}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr class="total s_separator" v-if="priceData.carryInPrice">
        <td>受け取り搬入サービス費</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(totalCarryPrice))}}</td>
      </tr>
      <tr v-if="priceData.carryInPrice">
        <td>消費税(10%)</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(totalCarryTax))}}</td>
      </tr>
      <tr class="total s_separator" v-if="priceData.executionVarExpensesPrice">
        <td>諸経費</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(priceData.executionVarExpensesPrice))}}</td>
      </tr>
      <tr v-if="priceData.executionVarExpensesTax">
        <td>消費税(10%)</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price">{{formatPrice(profitPrice(priceData.executionVarExpensesTax))}}</td>
      </tr>
      <tr class="total s_separator">
        <td>合計</td>
        <td></td>
        <td></td>
        <td></td>
        <td class="price pickup">{{formatPrice(profitPrice(totalPrice))}}</td>
      </tr>
    </table>
  </div>
</template>
<script>

export default {
  components: {
  },
  props: {
    priceData: {
      type: Object
    },
    isCalcDelivery: {
      type: Boolean,
      default: false
    },
    dcProductCount: {
      type: Number,
      default: 0
    },
    isProfitFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    itemList: function () {
      if (!this.priceData.itemModelList) return
      return this.priceData.itemModelList
        .filter(e => e.accessoryType === 'PLAN')
    },
    optionFillerList: function () {
      if (!this.priceData.itemModelList) return
      return this.priceData.itemModelList
        .filter(e => e.accessoryType === 'OPTION')
        .filter(e => e.objectDtlType === 'UNIT_FILLER')
    },
    optionShelfList: function () {
      if (!this.priceData.itemModelList) return
      return this.priceData.itemModelList
        .filter(e => e.accessoryType === 'OPTION')
        .filter(e => e.objectDtlType === 'UNIT_MOBILE_SHELF')
    },
    totalTax: function () {
      if (!this.priceData) return
      return this.priceData.taxPrice
    },
    totalCarryPrice: function () {
      return (this.priceData.carryInPrice ? this.priceData.carryInPrice : 0) *
        this.priceData.productCount
    },
    totalCarryTax: function () {
      return Math.floor(this.totalCarryPrice * 0.1)
    },
    totalPrice: function () {
      if (!this.priceData) return
      let price = this.priceData.totalPrice +
        (this.priceData.executionVarExpensesPrice ? this.priceData.executionVarExpensesPrice : 0) +
        (this.priceData.executionVarExpensesTax ? this.priceData.executionVarExpensesTax : 0) +
        this.totalCarryPrice + this.totalCarryTax
      return price
    }
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    profitPrice: function (price) {
      if (!this.isProfitFlag) return price
      return (Math.ceil(price / this.priceData.profitProb))
    },
    itemType: function (type) {
      if (type === 'PART_DOOR_BOARD') {
        return '扉:'
      } else if (type === 'UNIT_SKELTON') {
        return '箱:'
      } else if (type === 'UNIT_MOBILE_SHELF') {
        return '棚板：'
      } else if (type === 'UNIT_FILLER') {
        return 'フィラー：'
      }
      return ''
    },
    sizeName: function (w, h, d) {
      if (!w || !h || !d) return ''
      return w + '×' + h + '×' + d + '(mm)'
    }
  }
}
</script>
<style src="../../css/dctop.scss" lang="scss" scoped></style>
<style src="../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/payment/PriceListOld.vue